export default __webpack_public_path__ + "static/media/confirm-cover-letter.da74915f.png";